export default class EventController {
    gameController: any;
    globalEvents: any[] = [];
    sceneEvents: any[] = [];

    constructor(gameController: any){
        this.gameController = gameController;
        //Will need to filter
        this.gameController.addEventHandler(["scene:loaded"], 'event-controller', (event, data)=>{this.checkEvents(event)});
    }

    setGlobalEvents(events: any[]){
        this.globalEvents = events || [];
    }

    setSceneEvents(events: any[]){
        this.sceneEvents = events || [];
    }

    checkEvents(gameEvent: string){
        console.log("Checking events", this.sceneEvents);
        this.sceneEvents.forEach((event) => {
            if(gameEvent === event.trigger.type){
                if(!event.condition || this.checkCondition(event.condition)){
                    this.startActions(event);
                }
            }
        });
    }

    checkCondition(condition: any){
        if(!condition) return true;
        if(condition.type === "sceneState"){
            if(this.gameController.gameState.sceneState[condition.data.sceneState] && condition.operator !== "not"){
                return true
            } else if(!this.gameController.gameState.sceneState[condition.data.sceneState] && condition.operator === "not"){
                return true;
            }
        }
        return false;
    }

    startActions(event){
        event.actions.forEach((action) => {
            if(action.delay){
                setTimeout(()=>{
                    this.action(action);
                }, action.delay*1000);
            } else {
                this.action(action);
            }
        });
    }

    action(action: any){
        if(action.type === "sound"){
            this.gameController.audio.playAudio(action.data.audio, action.data.volume || 1, action.data.speed || 1);
        } else if(action.type === "level"){
            this.gameController.loadScene(action.data.scene);
        }
        if(action.sceneState){
            this.gameController.setSceneState(action.sceneState);
        }
    }
}